import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "./store/slices/pubLoginSlice"; 
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export default function PubRemove() {
    const dispatch = useDispatch();
    const phoneNo = useSelector(state => state.pubLogin.userPhone);
    const [password, setPassword] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const nav = useNavigate();

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleRemoveClick = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/removeProfile`, {
                phone: phoneNo,
                password: password
            });

            if (response.data.success) {
                alert("Your profile has been successfully removed.");
                dispatch(logout()); 
                nav('/');
            } else {
                alert("Password is incorrect. Please try again.");
            }
        } catch (error) {
            console.error("Error removing profile:", error);
            toast.error("You have entered an invalid password", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setShowConfirm(true); // Show confirmation dialog
    };

    const handleConfirm = () => {
        handleRemoveClick();
    };

    const handleCancel = () => {
        setShowConfirm(false); // Hide confirmation dialog
    };

    return (
        <div className="container d-flex flex-column align-items-center mt-5">
            <h1 className="text-center mb-4">Delete Profile</h1>
            <div className="card shadow-lg p-4" style={cardStyle}>
               
                    <h3 className="text-center text-danger display-6">You are about to delete your profile. All your data on this website will be permanently removed. This action cannot be undone.</h3>   
                
                <form className="form-group w-100" onSubmit={handleSubmit}>
                    <label htmlFor="passwordInput" style={labelStyle}>Enter Password to Confirm</label>
                    <input
                        type="password"
                        name="password"
                        id="passwordInput"
                        className="form-control mb-2"
                        style={inputStyle}
                        placeholder="Enter your password"
                        value={password}
                        onChange={handlePasswordChange}
                        required
                    />

                    <div className="justify-content-center d-flex">
                        <button type="submit" className="btn btn-danger btn-lg rounded-pill px-5 py-3 mt-4 mb-4 shadow">
                            Remove Profile
                        </button>
                    </div>
                </form>

                {showConfirm && (
                    <div className="confirmation-dialog mt-4">
                        <p className="text-center h5">
                            Are you sure you want to delete your profile? This action cannot be undone.
                        </p>
                        <div className="d-flex justify-content-center">
                            <button className="btn btn-danger mr-2 rounded-pill px-5 py-3 shadow" onClick={handleConfirm}>
                                Yes, Delete My Profile
                            </button>
                            <button className="btn btn-secondary rounded-pill px-5 py-3 shadow" onClick={handleCancel}>
                                Cancel
                            </button>
                        </div>
                    </div>
                )}
            </div>
            <ToastContainer />
        </div>
    );
}

const cardStyle = {
    background: "rgba(255, 255, 255, 0.2)", // Blurred background
    backdropFilter: "blur(15px)", // Apply blur effect
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
};

const labelStyle = {
    fontWeight: "bold", // Make labels bold
    color: "#000", // Ensure labels are clearly visible
};

const inputStyle = {
    fontWeight: "bold", // Make input text bold
    background: "rgba(255, 255, 255, 1)", // Solid background for inputs
    borderColor: "#000", // Darker border for inputs
};
